import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import CloseModalButton from "./CloseModalButton";
import { LocationCategoryTag } from "./LocationCategoryTag";
import PointDetailArray from "./PointDetailArray";
import PointDetailBoolean from "./PointDetailBoolean";
import PointDetailGeneric from "./PointDetailGeneric";

export default function PointDetail({
  selectedLocation,
  handlePointDetailClosed,
}) {
  const PROPERTIES_TO_DISPLAY = [
    { label: "Genres", key: "genres", type: "array" },
    { label: "Live", key: "live", type: "boolean" },
    { label: "DJ", key: "dj", type: "boolean" },
    { label: "Kapazität", key: "capacity" },
    { label: "Gründung", key: "year_established" },
    { label: "Besucherzahlen", key: "visitors" },
    { label: "Anzahl Künstler", key: "num_creators" },
    { label: "Angebot Aufnahme", key: "recording", type: "boolean" },
    { label: "Angebot Mixing", key: "mixing", type: "boolean" },
    { label: "Angebot Mastering", key: "mastering", type: "boolean" },
    { label: "Dauer in Tagen", key: "duration" },
    { label: "Anzahl der Räume", key: "rooms" },
    { label: "Studiengänge", key: "studiengangs", type: "array" },
    { label: "Instrumente", key: "musical_instruments", type: "array" },
    { label: "Privater Träger", key: "sponsor_private", type: "boolean" },
    { label: "Öffentlicher Träger", key: "sponsor_public", type: "boolean" },
  ];

  return (
    <Paper variant="locations-wrapper">
      <Box sx={categoryNameStyles(selectedLocation)}>
        <CloseModalButton
          type="point-details"
          handleToggle={handlePointDetailClosed}
        />

        <Box className="gradient" />
        <Grid
          container
          justifyContent="center"
          sx={{ zIndex: "500", position: "relative", gap: "0.5rem" }}
        >
          <Grid item xs="auto">
            <LocationCategoryTag
              text={
                selectedLocation.category?.name ??
                selectedLocation.properties.location.category.name
              }
              variant={`category--${
                selectedLocation.category?.name ??
                selectedLocation.properties.location.category.name
              }`}
              iconCategory={true}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" className="location-name">
              {selectedLocation.name ?? selectedLocation.properties.name}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Paper variant="map-location-description">
        <Box>
          {PROPERTIES_TO_DISPLAY.map((property, index) => {
            return (
              <Box key={property.key} sx={{ textAlign: "center" }}>
                <PointDetailArray
                  property={property}
                  location={
                    selectedLocation.properties?.location ?? selectedLocation
                  }
                />
                <PointDetailBoolean
                  property={property}
                  location={
                    selectedLocation.properties?.location ?? selectedLocation
                  }
                />
                <PointDetailGeneric
                  property={property}
                  location={
                    selectedLocation.properties?.location ?? selectedLocation
                  }
                />
              </Box>
            );

            /*return (
              (property.type === "array" &&
                (
                  selectedLocation[property.key] ||
                  selectedLocation.properties?.location[property.key]
                ).length > 0) ||
              (property.type === "boolean" &&
                (selectedLocation[property.key] ||
                  selectedLocation.properties?.location[property.key])) ||
              (property.type !== "boolean" &&
                property.type !== "array" &&
                (selectedLocation[property.key] ||
                  selectedLocation.properties?.location[property.key]) && (
                  <Grid item xs={12} key={property.key} align="center">
                    <Typography variant="body1" className="title">
                      {property.label}
                    </Typography>
                    <Typography variant="body1" className="value">
                      {property.type === "array" &&
                        (
                          selectedLocation[property.key] ??
                          selectedLocation.properties?.location[property.key]
                        )
                          .map((p) => p.name)
                          .join(", ")}
                      {property.type === "boolean" &&
                        (selectedLocation[property.key] ??
                        selectedLocation.properties?.location[property.key]
                          ? "Ja"
                          : "Nein")}
                      {property.type !== "boolean" &&
                        property.type !== "array" &&
                        (selectedLocation[property.key] ??
                          selectedLocation.properties?.location[property.key])}
                    </Typography>
                  </Grid>
                ))
            );*/
          })}
          {selectedLocation.properties?.location.website && (
            <Grid item xs={12} align="center">
              <Button
                component="a"
                target="_blank"
                rel="noopener"
                href={`${selectedLocation.properties?.location.website}`}
                fullWidth
                variant="outlined"
                color="secondary"
                className="website-link"
              >
                Zur Website
              </Button>
            </Grid>
          )}
          {selectedLocation.properties?.location.description && (
            <Grid item xs={12}>
              <Typography
                color="common.white"
                variant="body1"
                className="description"
              >
                {selectedLocation.properties?.location.description}
              </Typography>
            </Grid>
          )}
        </Box>
      </Paper>
    </Paper>
  );
}
const categoryNameStyles = (selectedLocation) => {
  return {
    backgroundColor: grey[900],
    padding: "2rem",
    position: "relative",
    "& .location-name": {
      color: "#fff !important",
      textAlign: "center",
    },
    "& .gradient": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      opacity: 0.25,
      background: `linear-gradient(180deg, ${grey[900]} 0%, ${
        selectedLocation.category?.color ??
        selectedLocation.properties.location.category.color
      } 100%)`,
    },
  };
};
